<template>
  <div v-if="error" class="login-alert p-3 text-center mb-3">
    <div class="text-primary">{{ error.error }}</div>
    <span v-html="error.msg"></span>
  </div>

  <div v-if="sign">
    <!-- <div class="mb-3 fw-bold">
      Для подписания анкеты лизингополучателя с помощью Nopaper необходимо:
    </div> -->

    <div class="row mb-4">
      <div class="col-auto">
        <div class="nopaper-step">1</div>
      </div>

      <div class="col pt-1">
        Если вы еще не авторизованы в мобильном приложении
        <a href="https://nopaper.ru/" target="_blank">Nopaper</a>, пройдите
        процедуру авторизации.
        <div class="mt-2">
          Используя ваш номер телефона:
          <span class="fw-bold">{{ props.phone }}</span>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-auto">
        <div class="nopaper-step">2</div>
      </div>

      <div class="col pt-1">
        Подпишите документ НЭП в мобильном приложении
        <a href="https://nopaper.ru/" target="_blank">Nopaper</a>.
      </div>
    </div>

    <div class="login-alert p-3 text-center mb-3">
      <div class="text-primary">Статус</div>
      <span>Документ передан в Nopaper для подписания</span>
    </div>

    <div class="d-flex flex-wrap gap-2">
      <ui-button
        @click="statusNopaper"
        :loading="loading"
        :disabled="loading"
        class="btn-base"
        >Обновить статус</ui-button
      >
      <ui-button @click="closeNopaper" :disabled="loading" class="btn btn-ghost"
        >Отклонить</ui-button
      >
    </div>

    <div class="mt-3">
      * Для отмены подписания при помощи ЭЦП нажмите кнопку Отклонить
    </div>
  </div>

  <div v-else>
    <div class="row">
      <div class="col-12">
        <div class="mb-3 fw-bold">
          Для подписания документа в приложении NoPaper (УНЭП):
        </div>

        <ul>
          <li>
            Установите
            <a href="https://nopaper.ru/" target="_blank">приложение Nopaper</a>
            на свой смартфон
          </li>
          <li>Зарегистрируйтесь в сервисе Nopaper</li>

          <li v-if="props.inn && /^\d{10}$/.test(String(props.inn))">
            Выпустить подпись компании
          </li>
        </ul>
      </div>
    </div>

    <div class="d-flex flex-wrap gap-2">
      <ui-button @click="nopaper" :loading="loading" class="btn-base"
        >Подписать</ui-button
      >
      <a href="https://nopaper.ru/edo/" target="_blank" class="btn btn-ghost"
        >О сервисе Noрaper</a
      >
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

import { useStore } from "vuex";

const store = useStore();

import { postApi } from "../../run";

const props = defineProps({
  uid: String,
  inn: {
    type: String,
  },
  phone: {
    type: String,
  },
  getFile: {
    type: Function,
    default: () => false,
  },
  setStatus: {
    type: Function,
  },
});

const error = ref(false);
const sign = computed(() => store.state.main.status > 0);
const loading = ref(false);

const nopaper = async () => {
  error.value = null;
  loading.value = true;
  await props
    .getFile()
    .then(async (res) => {
      if (res.error) {
        error.value = res;
      } else {
        await postApi("/nopaper", {
          UID: props.uid,
          base64File: res,
        }).then((res) => {
          if (res.error) {
            error.value = res;
          } else {
            props.setStatus(res.status);
          }
        });
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

const statusNopaper = () => {
  error.value = null;
  loading.value = true;
  postApi("/statusNopaper", {
    UID: props.uid,
  })
    .then((res) => {
      if (res.error) {
        error.value = res;
      } else {
        props.setStatus(res.status);
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

const closeNopaper = () => {
  error.value = null;
  loading.value = true;
  postApi("/closeNopaper", {
    UID: props.uid,
  })
    .then((res) => {
      if (res.error) {
        error.value = res;
      } else {
        props.setStatus(res.status);
      }
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>